export const extensions = [
  'mp4',
  'mkv',
  'wmv',
  'm4v',
  'mov',
  'avi',
  'flv',
  'webm',
  'flac',
  'mka',
  'm4a',
  'aac',
  'ogg',
];
